module.exports = __webpack_public_path__ + "static/key-planetcoaster-76eb4f2fb5e025e6098c9d2c893d1c55.webp";